const indexOf = [].indexOf
const { component, dom } = require('../odo/odojs/')
const inject = require('injectinto')
const ql = require('../odo/odoql/').use('store')
const normalpage = require('./normalpage')
const ballrollingpage = require('./ballrollingpage')
const loggedinpage = require('./loggedinpage')
const focuscomponent = require('../shared/focuscomponent')
const route = require('odo-route')
const markdown = require('../shared/markdown')

route('/', p => ({ page: 'login' }))

const getqueryparams = () => {
  const result = {}
  location.search
    .substr(1)
    .split('&')
    .forEach(item => {
      const chunks = item.split('=')
      result[chunks[0]] = decodeURIComponent(chunks[1])
    })
  return result
}

inject.bind(
  'page:login',
  component({
    query: params => ({
      identity: ql.store('identity'),
      portfolios: ql.store('portfolios'),
      content: ql.store(['login'], 'content')
    }),
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      const queryparams = getqueryparams()
      let email = queryparams['email']

      if (state.identity == null) {
        const rememberemail = e => {
          email = e.target.value
        }
        const login = e => {
          e.preventDefault()
          hub.emit('login', {
            email: email,
            return: queryparams['return']
          })
        }
        return ballrollingpage(
          dom('form.hero', { onsubmit: login }, [
            markdown(state.content.login),
            focuscomponent(
              dom('input', {
                onchange: rememberemail,
                style: { width: '20rem' },
                attributes: {
                  value: queryparams['email'],
                  autofocus: true,
                  required: true,
                  type: 'email',
                  autocomplete: 'email',
                  placeholder: 'Email address'
                }
              })
            ),
            ' ',
            dom('button.button', 'Login')
          ])
        )
      }

      return loggedinpage([
        dom(
          '.page--content',
          dom('.hero', [
            dom('p', `Welcome back ${state.identity.name}`),
            indexOf.call((ref = state.identity) != null ? ref.permissions : void 0, 'superpowers') >= 0
              ? [
                  dom(
                    'p',
                    dom(
                      'a.button',
                      {
                        attributes: {
                          href: '/p/admin/',
                          rel: 'external'
                        }
                      },
                      'Go to admin'
                    )
                  ),
                  dom('br')
                ]
              : void 0,
            dom('p', 'Select portfolio:'),
            dom(
              'ul.selection',
              {
                style: {
                  width: '20rem',
                  margin: '0 auto'
                }
              },
              state.portfolios.map(function (portfolio) {
                return dom(
                  'li',
                  dom(
                    '.selection--item',
                    dom(
                      'a',
                      {
                        attributes: {
                          href: `/p/${portfolio.subdomain}/`,
                          rel: 'external'
                        }
                      },
                      portfolio.name
                    )
                  )
                )
              })
            )
          ])
        )
      ])
    }
  })
)

route('/login/pending', p => ({ page: 'login:pending' }))

inject.bind(
  'page:login:pending',
  component({
    query: params => ({
      content: ql.store(['login_pending'], 'content')
    }),
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      return normalpage(dom('.hero', markdown(state.content.login_pending)))
    }
  })
)

route('/login/complete', p => ({ page: 'login:complete' }))

inject.bind(
  'page:login:complete',
  component({
    query: (params, hub) => ({
      content: ql.store(['login_complete'], 'content'),
      identity: ql.store('identity'),
      portfolios: ql.store('portfolios')
    }),
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      return normalpage(
        dom('.hero', [
          markdown(state.content.login_complete),
          dom('p', 'Portfolios available:'),
          dom(
            'ul.selection',
            {
              style: {
                width: '20rem',
                margin: '0 auto'
              }
            },
            state.portfolios.map(function (portfolio) {
              return dom(
                'li',
                dom(
                  '.selection--item',
                  dom('a', { attributes: { href: `/p/${portfolio.subdomain}/`, rel: 'external' } }, portfolio.name)
                )
              )
            })
          )
        ])
      )
    }
  })
)

route('/login/failed', p => ({ page: 'login:failed' }))

inject.bind(
  'page:login:failed',
  component({
    query: params => ({
      content: ql.store(['login_failed'], 'content')
    }),
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      return ballrollingpage(dom('.hero', markdown(state.content.login_failed)))
    }
  })
)

route('/loggedout', p => ({ page: 'loggedout' }))

inject.bind(
  'page:loggedout',
  component({
    query: params => ({
      content: ql.store(['loggedout'], 'content')
    }),
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      return ballrollingpage(dom('.hero', markdown(state.content.loggedout)))
    }
  })
)
